import { gql } from '@apollo/client';

export const DEBOUNCE_TIME = 700;

export const ORDER_COMPANIES_BY = 'name ASC';
export const ORDER_PROJECTS_BY = 'created_at DESC';

export const CREATE_USAGE_LOG = gql`
  mutation CreateUsageLog(
    $projectId: ID!,
    $companyId: ID, 
    $createdAt: String!, 
    $cost: Float!,
    $reason: String!
    ){
    createUsageLog(
        projectId: $projectId, 
        companyId: $companyId, 
        createdAt: $createdAt, 
        cost: $cost,
        reason: $reason
    ){
      usageLogs {
        id
      }
    }
  }
`;

export const GET_PROJECTS_BY_COMPANY = gql`
  query Projects($companyId: ID!, $limit: Int!, $offset: Int!, $order: String!, $name: String) {
    projects(companyId: $companyId, limit: $limit, offset: $offset, order: $order, name: $name) {
      id
      name
    }
  }
`;
